import { lazy, Suspense } from "react";
import Home from "@/pages/Home";
import { isHomePath } from "@/i18n/routing";
import "./i18n";

const NotFound = lazy(() => import("@/pages/not-found"));

function App() {
  const isNotFound = !isHomePath(window.location.pathname);

  if (isNotFound) {
    return (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    );
  }

  return <Home />;
}

export default App;
